import React, { useState, useEffect } from 'react';
import { FaWhatsapp, FaTimes } from 'react-icons/fa';
import { WHATSAPP_GENERAL_LINK } from '../data/products';

const WhatsAppButton = () => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), 2000);
        const tooltipTimer = setTimeout(() => setShowTooltip(true), 5000);
        return () => {
            clearTimeout(timer);
            clearTimeout(tooltipTimer);
        };
    }, []);

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-6 right-6 z-50">
            {showTooltip && (
                <div className="absolute bottom-full right-0 mb-3 animate-slide-up">
                    <div className="bg-white rounded-2xl shadow-2xl p-4 max-w-[260px] border border-green-100 relative">
                        <button onClick={() => setShowTooltip(false)}
                            className="absolute -top-2 -right-2 bg-gray-200 hover:bg-gray-300 rounded-full p-1">
                            <FaTimes size={10} className="text-gray-500" />
                        </button>
                        <div className="flex items-start gap-3">
                            <span className="text-2xl">🧁</span>
                            <div>
                                <p className="font-semibold text-gray-800 text-sm">¡Hola! 💕</p>
                                <p className="text-gray-600 text-xs mt-1">
                                    ¿Te antojaste? Haz tu pedido por WhatsApp y te atendemos con mucho cariño.
                                </p>
                            </div>
                        </div>
                        <div className="absolute -bottom-2 right-6 w-4 h-4 bg-white border-r border-b border-green-100 transform rotate-45" />
                    </div>
                </div>
            )}

            <a href={WHATSAPP_GENERAL_LINK} target="_blank" rel="noopener noreferrer"
                className="whatsapp-pulse block bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl transform hover:scale-110 transition-all duration-300 relative">
                <FaWhatsapp size={28} />
            </a>

            <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center animate-bounce">
                1
            </span>
        </div>
    );
};

export default WhatsAppButton;